module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/blue-wave/wave-opening-9ab84ca9b029c23a297f60baaebed9f5.svg";